import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text
} from 'mailup-web-components'
import InputLists from './InputLists'

import { saveSharedListsCallback } from 'Pages/SourceEdit/recoil/callbacks/callbacks'
import { modalSharedListsState } from 'Pages/SourceEdit/recoil/state/modals'

const ModalSharedLists = () => {
  const intl = useIntl()

  const [{ show, sharedLists }, setModal] = useRecoilState(
    modalSharedListsState
  )
  const handleConfirm = useRecoilCallback(saveSharedListsCallback, [])

  const handleClose = () => {
    setModal((prev) => ({ ...prev, show: false }))
  }

  return (
    <>
      <Modal
        show={show}
        showClose
        onClose={handleClose}
        data-mu-test='source-edit__modal-shared-lists'
      >
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.ContentsSouces.SharedModalTitle'
          })}
        />
        <ModalBody>
          <Text>
            {intl.formatMessage({
              id: 'Load.ContentsSouces.SharedModalDescr'
            })}
          </Text>
          <InputLists />
        </ModalBody>
        <ModalFoot>
          <Button onClick={handleClose} kind={BUTTON_VARIANT_SECONDARY}>
            {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
          </Button>
          <Button
            onClick={handleConfirm}
            kind='primary'
            disabled={!sharedLists.length}
          >
            {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
          </Button>
        </ModalFoot>
      </Modal>
    </>
  )
}

export default ModalSharedLists
